import React, { Component } from "react";

// Constants
import { API_WEB_URLS } from "../../constants/constAPI";

// Store & Functions
import {
  Fn_CheckBalance,
  Fn_FillListData,
  Fn_GetReport,
} from "../../store/functions";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Table,
  Badge,
  Spinner,
} from "reactstrap";

import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import "../Masters/datatables.scss";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

function getCurrentDate() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function formatCurrency(val) {
  if (val === null || val === undefined || isNaN(val)) {
    return "₹ 0.00";
  }
  const num = parseFloat(val);
  if (isNaN(num)) {
    return "₹ 0.00";
  }
  return (
    "₹ " +
    num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
}

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      aid: "",
      role: "",

      dashboarledgers: [],
      balances: {}, // ledgerId -> number (persisted)
      loadingBalances: {}, // ledgerId -> boolean
      isRefreshingAll: false,

      mirenE: [], // Cr balances list
      jyoti: [], // Dr balances list

      page: 1,
      sizePerPage: 25,
    };

    this.obj = this;
    this.breadCrumbTitle = "Accounting";
    this.breadCrumbItem = "Executive Dashboard";

    this.handrefresh = this.handrefresh.bind(this);
    this.handleRefreshAll = this.handleRefreshAll.bind(this);
    this.loadDashboardData = this.loadDashboardData.bind(this);
  }

  componentDidMount() {
    const obj = JSON.parse(sessionStorage.getItem("authUser")) || {};
    this.setState({
      name: obj.username || "",
      email: obj.email || "",
      aid: obj.uid || "",
      role: obj.role || "",
    });

    this.loadDashboardData();
  }

  loadDashboardData() {
    // 1. Fetch Key Dashboard Ledgers
    Fn_FillListData(
      this.obj,
      "dashboarledgers",
      API_WEB_URLS.MASTER + "/0/token/DashboardLedgers/Id/0"
    );

    // 2. Fetch Cr & Dr Balances
    const vformData = new FormData();
    vformData.append("Id", 10);
    vformData.append("From", "2000-01-01");
    vformData.append("To", getCurrentDate());

    Fn_GetReport(
      this.obj,
      { arguList: { id: 0, formData: vformData } },
      "GetCrDrBalances/0/token",
      "CrDrData",
      true
    );
  }

  // Single ledger real-time balance check
  handrefresh = async Id => {
    this.setState(prevState => ({
      loadingBalances: {
        ...prevState.loadingBalances,
        [Id]: true,
      },
    }));

    try {
      const bal = await Fn_CheckBalance(this.obj, Id);
      const safeBal =
        bal !== undefined && !isNaN(bal)
          ? parseFloat(bal)
          : parseFloat(this.state.Balance) || 0;

      this.setState(prevState => ({
        balances: {
          ...prevState.balances,
          [Id]: safeBal,
        },
        loadingBalances: {
          ...prevState.loadingBalances,
          [Id]: false,
        },
      }));
    } catch (error) {
      console.error("Error fetching balance for Id " + Id + ":", error);
      this.setState(prevState => ({
        loadingBalances: {
          ...prevState.loadingBalances,
          [Id]: false,
        },
      }));
    }
  };

  // Refresh all monitored dashboard ledgers at once
  handleRefreshAll = async () => {
    const ledgers = this.state.dashboarledgers;
    if (!ledgers || ledgers.length === 0) return;

    this.setState({ isRefreshingAll: true });

    for (let i = 0; i < ledgers.length; i++) {
      const item = ledgers[i];
      await this.handrefresh(item.Id);
    }

    this.setState({ isRefreshingAll: false });
  };

  render() {
    const { SearchBar } = Search;
    const {
      dashboarledgers = [],
      balances = {},
      loadingBalances = {},
      isRefreshingAll = false,
      mirenE = [],
      jyoti = [],
    } = this.state;

    // Robust sum calculation preventing any NaN
    const crList = Array.isArray(mirenE) ? mirenE : [];
    const drList = Array.isArray(jyoti) ? jyoti : [];

    const totalCr = crList.reduce((acc, row) => {
      const val = Math.abs(parseFloat(row && row.Amount) || 0);
      return acc + val;
    }, 0);

    const totalDr = drList.reduce((acc, row) => {
      const val = Math.abs(parseFloat(row && row.Amount) || 0);
      return acc + val;
    }, 0);

    const netDifference = totalDr - totalCr;

    // Table Columns Configuration
    const columnsCr = [
      {
        dataField: "Name",
        text: "Account / Ledger Name",
        sort: true,
        formatter: (cellContent, row) => (
          <span className="fw-semibold text-dark">
            <i className="bx bx-file-blank text-primary me-2"></i>
            {row.Name || "-"}
          </span>
        ),
        footer: () => <strong className="font-size-14">Total Credit</strong>,
      },
      {
        dataField: "Amount",
        text: "Balance",
        sort: true,
        headerStyle: { textAlign: "right" },
        style: { textAlign: "right" },
        formatter: (cellContent, row) => {
          const amt = Math.abs(parseFloat(row.Amount) || 0);
          return (
            <span className="fw-bold text-danger">
              {formatCurrency(amt)}
              <Badge color="soft-danger" className="ms-2 font-size-11">
                Cr
              </Badge>
            </span>
          );
        },
        footer: () => (
          <div className="text-end">
            <strong className="text-danger font-size-15">
              {formatCurrency(totalCr)}
              <Badge color="danger" className="ms-1">
                Cr
              </Badge>
            </strong>
          </div>
        ),
      },
    ];

    const columnsDr = [
      {
        dataField: "Name",
        text: "Account / Ledger Name",
        sort: true,
        formatter: (cellContent, row) => (
          <span className="fw-semibold text-dark">
            <i className="bx bx-file-blank text-success me-2"></i>
            {row.Name || "-"}
          </span>
        ),
        footer: () => <strong className="font-size-14">Total Debit</strong>,
      },
      {
        dataField: "Amount",
        text: "Balance",
        sort: true,
        headerStyle: { textAlign: "right" },
        style: { textAlign: "right" },
        formatter: (cellContent, row) => {
          const amt = Math.abs(parseFloat(row.Amount) || 0);
          return (
            <span className="fw-bold text-success">
              {formatCurrency(amt)}
              <Badge color="soft-success" className="ms-2 font-size-11">
                Dr
              </Badge>
            </span>
          );
        },
        footer: () => (
          <div className="text-end">
            <strong className="text-success font-size-15">
              {formatCurrency(totalDr)}
              <Badge color="success" className="ms-1">
                Dr
              </Badge>
            </strong>
          </div>
        ),
      },
    ];

    const defaultSorted = [
      {
        dataField: "Name",
        order: "asc",
      },
    ];

    const paginationOptions = {
      sizePerPage: 25,
      sizePerPageList: [
        { text: "10", value: 10 },
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
      ],
      custom: true,
    };

    return (
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumb & Title */}
          <Breadcrumbs
            title={this.breadCrumbTitle}
            breadcrumbItem={this.breadCrumbItem}
          />

          {/* Top KPI Cards Row */}
          <Row className="mb-3">
            {/* 1. Total Credit */}
            <Col xl="3" md="6">
              <Card className="mini-stats-wid border shadow-sm">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium mb-1">Total Credit (Cr)</p>
                      <h4 className="mb-0 text-danger fw-bold font-size-22">
                        {formatCurrency(totalCr)}
                      </h4>
                      <p className="text-muted font-size-12 mb-0 mt-2">
                        <span className="badge badge-soft-danger me-1">
                          {crList.length} Accounts
                        </span>
                        Payables & Liabilities
                      </p>
                    </div>
                    <div className="avatar-sm rounded-circle bg-danger align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-soft-danger text-danger font-size-24">
                        <i className="bx bx-down-arrow-circle"></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* 2. Total Debit */}
            <Col xl="3" md="6">
              <Card className="mini-stats-wid border shadow-sm">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium mb-1">Total Debit (Dr)</p>
                      <h4 className="mb-0 text-success fw-bold font-size-22">
                        {formatCurrency(totalDr)}
                      </h4>
                      <p className="text-muted font-size-12 mb-0 mt-2">
                        <span className="badge badge-soft-success me-1">
                          {drList.length} Accounts
                        </span>
                        Receivables & Assets
                      </p>
                    </div>
                    <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-soft-success text-success font-size-24">
                        <i className="bx bx-up-arrow-circle"></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* 3. Net Difference */}
            <Col xl="3" md="6">
              <Card className="mini-stats-wid border shadow-sm">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium mb-1">Net Balance Difference</p>
                      <h4
                        className={`mb-0 fw-bold font-size-22 ${
                          netDifference === 0
                            ? "text-primary"
                            : netDifference > 0
                            ? "text-success"
                            : "text-danger"
                        }`}
                      >
                        {formatCurrency(Math.abs(netDifference))}
                      </h4>
                      <p className="text-muted font-size-12 mb-0 mt-2">
                        {netDifference === 0 ? (
                          <Badge color="soft-primary" className="font-size-11">
                            <i className="bx bx-check-double me-1"></i> Perfect Tally
                          </Badge>
                        ) : netDifference > 0 ? (
                          <Badge color="soft-success" className="font-size-11">
                            <i className="bx bx-plus-circle me-1"></i> Debit Surplus
                          </Badge>
                        ) : (
                          <Badge color="soft-danger" className="font-size-11">
                            <i className="bx bx-minus-circle me-1"></i> Credit Surplus
                          </Badge>
                        )}
                      </p>
                    </div>
                    <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-soft-primary text-primary font-size-24">
                        <i className="bx bx-calculator"></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* 4. Monitored Accounts & Actions */}
            <Col xl="3" md="6">
              <Card className="mini-stats-wid border shadow-sm">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium mb-1">Live Monitor Ledgers</p>
                      <h4 className="mb-0 text-dark fw-bold font-size-22">
                        {dashboarledgers.length} Ledgers
                      </h4>
                      <div className="mt-2">
                        <Button
                          color="primary"
                          size="sm"
                          className="btn-rounded waves-effect font-size-11 px-2 py-1"
                          onClick={this.loadDashboardData}
                        >
                          <i className="bx bx-sync me-1"></i> Sync Data
                        </Button>
                      </div>
                    </div>
                    <div className="avatar-sm rounded-circle bg-info align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-soft-info text-info font-size-24">
                        <i className="bx bx-line-chart"></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Key Account Balances Live Monitor Widget */}
          <Row className="mb-4">
            <Col lg="12">
              <Card className="border shadow-sm">
                <CardBody>
                  <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2">
                    <div>
                      <h5 className="card-title mb-1 text-primary fw-bold">
                        <i className="bx bx-wallet-alt me-2 font-size-18"></i>
                        Key Account Balances (Real-Time Monitor)
                      </h5>
                      <p className="text-muted font-size-13 mb-0">
                        Check real-time ledger balance for cash, bank, wallets, and settlement portals anytime.
                      </p>
                    </div>
                    <div>
                      <Button
                        color="primary"
                        size="sm"
                        className="btn-rounded"
                        disabled={isRefreshingAll || dashboarledgers.length === 0}
                        onClick={this.handleRefreshAll}
                      >
                        {isRefreshingAll ? (
                          <>
                            <Spinner size="sm" className="me-1" />
                            Checking All...
                          </>
                        ) : (
                          <>
                            <i className="bx bx-refresh me-1 font-size-14"></i>
                            Check All Balances
                          </>
                        )}
                      </Button>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <Table className="table align-middle table-hover mb-0">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "60px" }}>#</th>
                          <th>Ledger Name</th>
                          <th style={{ width: "240px" }} className="text-center">
                            Live Balance
                          </th>
                          <th style={{ width: "180px" }} className="text-end">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {dashboarledgers && dashboarledgers.length > 0 ? (
                          dashboarledgers.map((item, index) => {
                            const isRowLoading = loadingBalances[item.Id] === true;
                            const hasBalance =
                              balances[item.Id] !== undefined &&
                              balances[item.Id] !== null;
                            const rawBal = hasBalance ? parseFloat(balances[item.Id]) || 0 : 0;
                            const balVal = Math.abs(rawBal);

                            return (
                              <tr key={item.Id || index}>
                                <td>
                                  <span className="text-muted fw-bold">
                                    {index + 1}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="avatar-xs me-2">
                                      <span className="avatar-title rounded-circle bg-soft-primary text-primary font-size-14">
                                        <i className="bx bx-building-house"></i>
                                      </span>
                                    </div>
                                    <span className="fw-semibold text-dark font-size-14">
                                      {item.Name}
                                    </span>
                                  </div>
                                </td>
                                <td className="text-center">
                                  {isRowLoading ? (
                                    <span className="text-primary font-size-13">
                                      <Spinner size="sm" className="me-2" />
                                      Fetching balance...
                                    </span>
                                  ) : hasBalance ? (
                                    <span className="font-size-14 fw-bold text-success px-3 py-1 bg-soft-success rounded-pill d-inline-block">
                                      {formatCurrency(balVal)}
                                    </span>
                                  ) : (
                                    <span className="badge badge-soft-secondary font-size-12 px-2 py-1">
                                      Not Checked Yet
                                    </span>
                                  )}
                                </td>
                                <td className="text-end">
                                  <Button
                                    size="sm"
                                    color={hasBalance ? "info" : "primary"}
                                    outline={!isRowLoading}
                                    disabled={isRowLoading || isRefreshingAll}
                                    className="btn-rounded waves-effect"
                                    onClick={() => this.handrefresh(item.Id)}
                                  >
                                    <i
                                      className={`bx ${
                                        hasBalance ? "bx-refresh" : "bx-show"
                                      } me-1 font-size-14 align-middle`}
                                    ></i>
                                    {hasBalance ? "Re-Check" : "View Balance"}
                                  </Button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center py-4 text-muted">
                              <i className="bx bx-info-circle font-size-22 d-block mb-1"></i>
                              No monitored ledgers configured yet.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Two Columns: Cr Balances & Dr Balances */}
          <Row>
            {/* Credit (Cr) Balances Table */}
            <Col lg="6">
              <Card className="border shadow-sm">
                <CardBody>
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div>
                      <h5 className="card-title text-danger mb-1 fw-bold">
                        <i className="bx bx-down-arrow-circle me-1 font-size-18"></i>
                        Credit Balances (Cr)
                      </h5>
                      <span className="text-muted font-size-12">
                        {crList.length} Accounts Found
                      </span>
                    </div>
                    <Badge color="soft-danger" className="font-size-13 py-1 px-2">
                      Total: {formatCurrency(totalCr)}
                    </Badge>
                  </div>

                  <PaginationProvider
                    pagination={paginationFactory({
                      ...paginationOptions,
                      totalSize: crList.length,
                    })}
                    keyField="Id"
                    columns={columnsCr}
                    data={crList}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="Id"
                        columns={columnsCr}
                        data={crList}
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col md="6">
                                <div className="search-box me-2 d-inline-block w-100">
                                  <div className="position-relative">
                                    <SearchBar
                                      {...toolkitProps.searchProps}
                                      placeholder="Search Credit Account..."
                                      className="form-control form-control-sm"
                                    />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                            </Row>

                            <div className="table-responsive">
                              <BootstrapTable
                                keyField="Id"
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                classes="table align-middle table-nowrap table-hover"
                                headerWrapperClasses="thead-light"
                                noDataIndication={() => (
                                  <div className="text-center py-4 text-muted">
                                    <i className="bx bx-check-circle font-size-22 text-success d-block mb-1"></i>
                                    No Credit Balances
                                  </div>
                                )}
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                              />
                            </div>

                            <Row className="align-items-md-center mt-3">
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                </div>
                                <div className="text-md-right ms-auto">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>

            {/* Debit (Dr) Balances Table */}
            <Col lg="6">
              <Card className="border shadow-sm">
                <CardBody>
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div>
                      <h5 className="card-title text-success mb-1 fw-bold">
                        <i className="bx bx-up-arrow-circle me-1 font-size-18"></i>
                        Debit Balances (Dr)
                      </h5>
                      <span className="text-muted font-size-12">
                        {drList.length} Accounts Found
                      </span>
                    </div>
                    <Badge color="soft-success" className="font-size-13 py-1 px-2">
                      Total: {formatCurrency(totalDr)}
                    </Badge>
                  </div>

                  <PaginationProvider
                    pagination={paginationFactory({
                      ...paginationOptions,
                      totalSize: drList.length,
                    })}
                    keyField="Id"
                    columns={columnsDr}
                    data={drList}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="Id"
                        columns={columnsDr}
                        data={drList}
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col md="6">
                                <div className="search-box me-2 d-inline-block w-100">
                                  <div className="position-relative">
                                    <SearchBar
                                      {...toolkitProps.searchProps}
                                      placeholder="Search Debit Account..."
                                      className="form-control form-control-sm"
                                    />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                            </Row>

                            <div className="table-responsive">
                              <BootstrapTable
                                keyField="Id"
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                classes="table align-middle table-nowrap table-hover"
                                headerWrapperClasses="thead-light"
                                noDataIndication={() => (
                                  <div className="text-center py-4 text-muted">
                                    <i className="bx bx-check-circle font-size-22 text-success d-block mb-1"></i>
                                    No Debit Balances
                                  </div>
                                )}
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                              />
                            </div>

                            <Row className="align-items-md-center mt-3">
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                </div>
                                <div className="text-md-right ms-auto">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default compose(container)(Dashboard);
